<template>
    <FeaturesWithMedia
        class="slice slice-features slice-features--with-demo"
        :slice="props.slice"
        variation-modifier="with-video"
        default-anchor-id="features-with-video"
        :reverse="props.slice.primary.reverse"
    >
        <MuiWrapperWithShapes
            enable-full-screen
            enable-scale-on-hover
            :is-fullscreen-loading="!isDemoLoaded"
            :theme="props.slice.primary.theme"
            @fullscreen:hide="onDemoUnloaded"
        >
            <NuxtImg v-if="props.slice.primary.coverImage.url" :src="props.slice.primary.coverImage.url" class="slice-features--with-demo__image" />
            <template #fullscreen>
                <iframe :src="`${props.slice.primary.demoUrl}`" frameborder="0" class="slice-features--with-demo__iframe" :onload="onDemoLoaded" />
            </template>
        </MuiWrapperWithShapes>
    </FeaturesWithMedia>
</template>

<script setup lang="ts">
    import {ref} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';

    import type {FeaturesSlice} from '@prismicio-types';
    import {MuiWrapperWithShapes} from '#components';
    import FeaturesWithMedia from '../components/FeaturesWithMedia.vue';

    type FeaturesWithDemoInZone = Extract<FeaturesSlice, {variation: 'featuresWithDemo'}>;

    const props = defineProps(getSliceComponentProps<FeaturesWithDemoInZone>());

    const {isDemoLoaded, onDemoLoaded, onDemoUnloaded} = getDemo();

    function getDemo() {
        const isDemoLoaded = ref(false);

        function onDemoLoaded() {
            setTimeout(() => (isDemoLoaded.value = true), 500);
        }
        function onDemoUnloaded() {
            isDemoLoaded.value = false;
        }

        return {
            isDemoLoaded,
            onDemoLoaded,
            onDemoUnloaded,
        };
    }
</script>

<style lang="scss">
    .slice-features--with-demo {
        .mui-c-wrapper-with-shapes__content {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &__iframe {
            width: 100%;
            height: 100%;
            border: none;
        }
    }
</style>
